declare global {
  interface Window {
    hsConversationsSettings?: {loadImmediately?: boolean};
  }
}

export function loadHubspot() {
  window.hsConversationsSettings = {loadImmediately: false};

  const script = document.createElement('script');
  script.id = 'hs-script-loader';
  script.type = 'text/javascript';
  script.async = true;
  script.defer = true;
  script.src = 'https://js-na1.hs-scripts.com/20745831.js';
  document.head.appendChild(script);
}
